export default __webpack_public_path__ + "static/media/mentoriaLEP.7661739f.png";